import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide("captureEvent", (key: string) => key); // Provides $captureEvent as a global method temporary
});
